export default "__VITE_ASSET__mAdy9VTz__"